declare global {
  interface Window {
    RN_PLATFORM?: 'android' | 'ios';
  }
}

const SHELL_PLATFORMS = ['android', 'ios'];

// the shell replaced the user agent wholesale, so these are complete strings --
// matching on substrings would also catch the real browsers they were copied from
const SHELL_USER_AGENTS = [
  'Chrome/83.0.4103.106 Mobile Safari/537.36',
  'AppleWebKit/602.1.50 (KHTML, like Gecko) CriOS/56.0.2924.75',
];

export const isShellPlatform = (value: unknown): value is 'android' | 'ios' =>
  typeof value === 'string' && SHELL_PLATFORMS.includes(value);

export const isNativeShell = () =>
  isShellPlatform(window.RN_PLATFORM) ||
  SHELL_USER_AGENTS.includes(navigator.userAgent);
